module.exports = __webpack_public_path__ + "media/images/icons/facebook_blue-1f4d76f85ebfa635a0e41443e921d6fe.svg";